import type { RequestForm } from "~/types/main";
import { FormService } from "~/services/form.service";
import { FetchError } from "ofetch";

export const useFormStore = defineStore("form", () => {
  const errorMessage = ref("");
  const successMessage = ref("");

  async function requestForm(body: RequestForm) {
    errorMessage.value = "";
    successMessage.value = "";
    try {
      await FormService.postRequestForm(body);

      successMessage.value = "Your request has been sent successfully.";
      return true;
    } catch (e) {
      const errorMessageResponse =
        e instanceof FetchError
          ? (e.data?.message ?? "Network issues")
          : "Please check your details and try again.";
      console.log(errorMessageResponse);
      errorMessage.value = errorMessageResponse;
    }
  }

  return { errorMessage, successMessage, requestForm };
});
